/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** Date (isoformat) */
  Date: { input: string; output: string; }
  /** Date with time (isoformat) */
  DateTime: { input: string; output: string; }
  /** Decimal (fixed-point) */
  Decimal: { input: any; output: any; }
  UUID: { input: string; output: string; }
  /** Represents NULL values */
  Void: { input: void; output: void; }
};

export type ActionQrStatus = {
  __typename: 'ActionQrStatus';
  /** The openid of the user who scanned the QR code. This field is always present when a user scans the weapp qrcode, even if the user is not registered in the system. */
  openid: Scalars['ID']['output'];
  /** The unique identifier for the QR code that is scanned or expired. */
  qrid: Scalars['ID']['output'];
  status: QrStatus;
  /** The ID of the user who scanned the QR code, if the user is registered in the system. */
  userId?: Maybe<Scalars['ID']['output']>;
};

export type AdminUser = User & {
  __typename: 'AdminUser';
  /** The file name of the user avatar image. */
  avatar?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Gender>;
  /** The unique identifier for the user in the database */
  id?: Maybe<Scalars['ID']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
  /** The name the user choose to display in the app, can be anything. */
  name?: Maybe<Scalars['String']['output']>;
  openid: Scalars['ID']['output'];
  ratingSingles?: Maybe<Scalars['Float']['output']>;
  /** The role of the user at the site. */
  role: Scalars['String']['output'];
};

/** The smallest unit representing a court within a site. */
export type Court = {
  __typename: 'Court';
  /** Display order of the court within the site. */
  displayOrder: Scalars['Int']['output'];
  /** The unique identifier of the court. */
  id: Scalars['UUID']['output'];
  /** The name of the court. */
  name: Scalars['String']['output'];
};

/** Input for creating or updating a court. */
export type CourtInput = {
  /** Display order of the court. */
  displayOrder: Scalars['Int']['input'];
  /** Court ID. If None, a new court will be created. */
  id?: InputMaybe<Scalars['UUID']['input']>;
  /** The name of the court. */
  name: Scalars['String']['input'];
};

export type CreateBookingOrderResponse = CreateOrderResponse | GraphqlRequestError;

export type CreateEventInput = {
  /** The court where the event takes place. */
  courtId: Scalars['UUID']['input'];
  description: Scalars['String']['input'];
  /** The maximum number of participants allowed in the event. */
  drawSize: Scalars['Int']['input'];
  /** Duration of the event in hours. */
  duration: Scalars['Int']['input'];
  /** The event registration fee in CNY, unit cent. */
  fee?: Scalars['Int']['input'];
  location: Scalars['String']['input'];
  name: Scalars['String']['input'];
  /**
   * Number of players signed up for the event. ->
   *
   * Note this number is increased after the signup fee is **confirmed** to be received by the wepay callback. Thus it could be higher than drawSize due to the time lag between user requesting payment and the payment callback being received. The event organizer should then determine what to do with the over-booking players.
   */
  numSignups?: Scalars['Int']['input'];
  /** Minimum rating required to participate in the event. */
  requiredRating?: InputMaybe<Scalars['Float']['input']>;
  /** The site where the event takes place. */
  siteId: Scalars['UUID']['input'];
  startTime: Scalars['DateTime']['input'];
};

export type CreateMatchInput = {
  /** Indicates whether the match is a doubles match. */
  isDoubles: Scalars['Boolean']['input'];
};

/**
 * Parameters to be used in wx.requestPayment
 * see: https://pay.weixin.qq.com/doc/v3/merchant/4012365341
 */
export type CreateOrderResponse = {
  __typename: 'CreateOrderResponse';
  /** Parameters to be used in wx.requestPayment on the client side. Since the signing requires the merchant's private key, the payment params must be generated on the server side and sent to the client. */
  jsapiPaymentParams: JsapiPaymentParams;
  /** The internal order ID in the database */
  orderId?: Maybe<Scalars['UUID']['output']>;
  /** The merchant order number for the payment. Can be used to check payment status. */
  outTradeNo: Scalars['UUID']['output'];
};

export type DuelJoinedEvent = {
  __typename: 'DuelJoinedEvent';
  /** The id of the match joined. */
  matchId: Scalars['UUID']['output'];
  /** The user who joined the match. */
  player: UserBasic;
};

export enum Event_Status {
  Aborted = 'ABORTED',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Created = 'CREATED',
  Started = 'STARTED'
}

export enum EndDuelStatus {
  /** The duel was deleted because it ended before any score was submitted. */
  Deleted = 'DELETED',
  /** The duel was marked as ended. */
  Ended = 'ENDED'
}

/** A tournament event */
export type Event = {
  __typename: 'Event';
  /** The court where the event takes place. */
  courtId: Scalars['UUID']['output'];
  /** The user ID of the event creator. */
  creatorId: Scalars['UUID']['output'];
  description: Scalars['String']['output'];
  /** The maximum number of participants allowed in the event. */
  drawSize: Scalars['Int']['output'];
  /** Duration of the event in hours. */
  duration: Scalars['Int']['output'];
  eventStatus: Event_Status;
  /** The event registration fee in CNY, unit cent. */
  fee: Scalars['Int']['output'];
  /** The unique identifier for the event. */
  id: Scalars['ID']['output'];
  location: Scalars['String']['output'];
  /** An unordered list of matches for the event. */
  matches: Array<EventMatch>;
  name: Scalars['String']['output'];
  /**
   * Number of players signed up for the event. ->
   *
   * Note this number is increased after the signup fee is **confirmed** to be received by the wepay callback. Thus it could be higher than drawSize due to the time lag between user requesting payment and the payment callback being received. The event organizer should then determine what to do with the over-booking players.
   */
  numSignups: Scalars['Int']['output'];
  /** A list of players currently effectively signed up for the event, ordered by their **seeding position** in the event, which is determined by their rating and signup time. The highest rated player who signed up earliest get the top seeding position. Once the event is started, the list and its order will not change anymore. */
  players: Array<EventPlayer>;
  /** Minimum rating required to participate in the event. */
  requiredRating?: Maybe<Scalars['Float']['output']>;
  /** Whether the requesting user has a currently valid signup for the event */
  signedUp?: Maybe<Scalars['Boolean']['output']>;
  /** The site where the event takes place. */
  siteId: Scalars['UUID']['output'];
  startTime: Scalars['DateTime']['output'];
};

export type EventConnection = {
  __typename: 'EventConnection';
  /** A list of edges in this connection. */
  edges: Array<EventEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type EventEdge = {
  __typename: 'EventEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Event;
};

export enum EventFilterTab {
  /** Filters for publish events that are available for signup. That is, events not yet started or completed or cancelled, and not fully signed-up. */
  Available = 'AVAILABLE',
  /** Filters for events that are created by the user. */
  CreatedByMe = 'CREATED_BY_ME',
  /** Filters for events that the user has signed up for. Cancelled or pending signups do not counted */
  MySignedUp = 'MY_SIGNED_UP'
}

export type EventMatch = {
  __typename: 'EventMatch';
  /** The unique identifier of the `EventMatch`. */
  id: Scalars['UUID']['output'];
  /** The `Match` object. There will be multiple matches in a round, and each match in an `Event` usually consists of only one `MatchSet`, though this is not always the case. */
  match: Match;
  /** Which round does the match belong to. The round number starts from 1 and spans the entire event across different stages. */
  round: Scalars['Int']['output'];
};

export type EventPlayer = {
  __typename: 'EventPlayer';
  /** The unique identifier. */
  id: Scalars['UUID']['output'];
  /** The rank of the player in the event, if applicable. */
  rank?: Maybe<Scalars['Int']['output']>;
  /** The user who is a player in the event. */
  user: UserBasic;
};

export type File = {
  __typename: 'File';
  bucket: Scalars['String']['output'];
  createTime: Scalars['DateTime']['output'];
  fileName?: Maybe<Scalars['String']['output']>;
  hash: Scalars['String']['output'];
  mimeType?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};

export type FileUploadArgs = {
  __typename: 'FileUploadArgs';
  OSSAccessKeyId: Scalars['String']['output'];
  SecurityToken: Scalars['String']['output'];
  Signature: Scalars['String']['output'];
  bucketUrl: Scalars['String']['output'];
  callback: Scalars['String']['output'];
  key: Scalars['String']['output'];
  policy: Scalars['String']['output'];
};

export type FileUploadInput = {
  /** sha-1 file hash, base64-encoded (28 characters) */
  hash: Scalars['String']['input'];
  name: Scalars['String']['input'];
  type?: Scalars['String']['input'];
};

export enum Gender {
  Female = 'FEMALE',
  Male = 'MALE',
  Other = 'OTHER'
}

/** This type is used as the response type for all mutations that does not return any value */
export type GenericMutationResponse = GraphqlRequestError | GraphqlSuccess;

/** Business logic errors that users can encounter during normal operation. These errors represent valid application states (e.g., race conditions, resource exhaustion, state conflicts) and are displayed to users with localized error messages. */
export type GraphqlRequestError = {
  __typename: 'GraphqlRequestError';
  code: RequestErrorCode;
  /** Error message that will be displayed to the user. */
  message?: Maybe<Scalars['String']['output']>;
};

/** Indicator of a successful GraphQL mutation without response data */
export type GraphqlSuccess = {
  __typename: 'GraphqlSuccess';
  success: Scalars['Boolean']['output'];
};

export type JsapiPaymentParams = {
  __typename: 'JsapiPaymentParams';
  /** Used for calculating the pay sign, must be unique */
  nonceStr: Scalars['String']['output'];
  /** The prepay_id returned by the JSAPI payment request, formatted as the string "prepay_id=<value>". Pass this directly as the package parameter to wx.requestPayment. */
  package: Scalars['String']['output'];
  /** base64 encoded signature for the payment request */
  paySign: Scalars['String']['output'];
  /** Must be RSA for apiv3 */
  signType: Scalars['String']['output'];
  /** Timestamp for the payment request, in seconds since epoch, used for calculating the pay sign */
  timeStamp: Scalars['String']['output'];
};

export type LoginAdminResponse = {
  __typename: 'LoginAdminResponse';
  authToken: Scalars['String']['output'];
  user: SiteAdmin;
};

export type LoginAdminResponseUnion = GraphqlRequestError | LoginAdminResponse;

export type LoginResponse = {
  __typename: 'LoginResponse';
  authToken: Scalars['String']['output'];
  user: UserBasic;
};

export type LoginResponseUnion = GraphqlRequestError | LoginResponse;

export enum Match_Status {
  Created = 'CREATED',
  Ended = 'ENDED'
}

/** A tennis match is a collection of sets played between two players or two teams. */
export type Match = {
  __typename: 'Match';
  /** The time when the match was created in the database. */
  createTime?: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the user who created the match. */
  creatorId: Scalars['ID']['output'];
  /** The unique identifier for the game. */
  id: Scalars['ID']['output'];
  /** Indicates whether the match is a doubles match. */
  isDoubles: Scalars['Boolean']['output'];
  /** The current status of the match. */
  matchStatus: Match_Status;
  players: Array<MatchPlayer>;
  /** The time when the match score was last updated. Used as a version indicator to avoid accepting or rejecting the previous version of match score. */
  scoreUpdateTime?: Maybe<Scalars['DateTime']['output']>;
  sets: Array<MatchSet>;
  /** Number of **sets** won by player/team 1 in the match. */
  side1Score?: Maybe<Scalars['Int']['output']>;
  /** Number of **sets** won by player/team 2 in the match. */
  side2Score?: Maybe<Scalars['Int']['output']>;
};

export type MatchConnection = {
  __typename: 'MatchConnection';
  /** A list of edges in this connection. */
  edges: Array<MatchEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type MatchEdge = {
  __typename: 'MatchEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Match;
};

export type MatchPlayer = {
  __typename: 'MatchPlayer';
  id: Scalars['UUID']['output'];
  /** Indicates whether the player has accepted (True) or rejected (False) the match score. Null indicates not yet responded. */
  scoreAccepted?: Maybe<Scalars['Boolean']['output']>;
  /** The time when the player provided feedback on the match score. */
  scoreFeedbackTime?: Maybe<Scalars['DateTime']['output']>;
  /** The side of the match the player is on (1 or 2). The match creator is always on side 1. */
  side: Scalars['Int']['output'];
  /** The user who is a player in the match. */
  user: UserBasic;
  /** The unique identifier of the user who is a player in the match. */
  userId: Scalars['UUID']['output'];
};

export type MatchScoreFeedbackResponse = GraphqlRequestError | MatchScoreStatusChanged;

export type MatchScoreStatusChanged = {
  __typename: 'MatchScoreStatusChanged';
  scoreAccepted: Scalars['Boolean']['output'];
  scoreFeedbackTime: Scalars['DateTime']['output'];
};

export type MatchScoreUpdated = {
  __typename: 'MatchScoreUpdated';
  scoreUpdateTime: Scalars['DateTime']['output'];
  sets: Array<MatchSet>;
  side1Score: Scalars['Int']['output'];
  side2Score: Scalars['Int']['output'];
};

/** A match set is a collection of games. */
export type MatchSet = {
  __typename: 'MatchSet';
  /** The set number, starting from 1. */
  setNumber: Scalars['Int']['output'];
  /** Number of **games** won by player/team 1 in the **set**. */
  side1Score: Scalars['Int']['output'];
  /** Tiebreak points of player/team 1, if applicable. */
  side1TiebreakPoints?: Maybe<Scalars['Int']['output']>;
  /** Number of **games** won by player/team 2 in the **set**. */
  side2Score: Scalars['Int']['output'];
  /** Tiebreak points of player/team 2, if applicable. */
  side2TiebreakPoints?: Maybe<Scalars['Int']['output']>;
};

export type MatchSetInput = {
  /** The set number, starting from 1. */
  setNumber: Scalars['Int']['input'];
  /** Number of **games** won by player/team 1 in the **set**. */
  side1Score: Scalars['Int']['input'];
  /** Tiebreak points of player/team 1, if applicable. */
  side1TiebreakPoints?: InputMaybe<Scalars['Int']['input']>;
  /** Number of **games** won by player/team 2 in the **set**. */
  side2Score: Scalars['Int']['input'];
  /** Tiebreak points of player/team 2, if applicable. */
  side2TiebreakPoints?: InputMaybe<Scalars['Int']['input']>;
};

export type Mutation = {
  __typename: 'Mutation';
  /** The player accepts the score of the match. For duels, if all the players accept the score, the match is ended. */
  acceptMatchScore: MatchScoreFeedbackResponse;
  /** Create a new site. The creating user becomes the super-admin of the site. */
  addSite: Site;
  /** Add a user as an admin or super_admin to a site. Only super_admins of the site can call this mutation. This is called by the SPA from ActionQrDialog's onScanned callback after the Mini Program notifies that a user has scanned the QR code. Returns a success response if the user was added successfully. */
  addSiteAdmin: GenericMutationResponse;
  /**
   * Cancel the booking of specified slots.
   *
   * After a user makes successful booking of the slots, this mutation allows her to cancel the booking and request a refund according to the refund policy.
   *
   * **Partial Cancellation:**
   * Users can cancel a subset of slots from their original booking. The refund amount is calculated for the cancelled slots based on the refund policy.
   *
   * **Refund Policy:**
   * - **< 4 hours before**: Cancellation not allowed (no refund)
   * - **< 24 hours before**: 50% refund
   * - **≥ 24 hours before**: 70% refund
   *
   * **Validation:**
   * - All slots must belong to the same order owned by the current user
   * - Must cancel at least 4 hours before the earliest slot
   *
   * **Note:** The actual slot release and refund are performed asynchronously via a background workflow. This mutation only validates and enqueues the request.
   */
  cancelBookingOrder: GenericMutationResponse;
  /** Cancel an event. If any valid signups exist, the players will be refunded. */
  cancelEvent: GenericMutationResponse;
  /**
   * Cancel the event payment request.
   *
   * When the user presses the pay button to signup for the event, but somehowaborts the payment in WeChat, we need to immediately remove the pending signup record to free up the slot for other users.
   */
  cancelEventPayment?: Maybe<Scalars['Void']['output']>;
  /** Request to cancel an already paid event signup. The refund will be handled asynchronously. */
  cancelEventSignup: GenericMutationResponse;
  /**
   * Cancel a pending order and release associated resources.
   *
   * This mutation is called when the user explicitly indicates they no longer want to pay for the order. It marks the order as CLOSED and performs order-type-specific cleanup:
   *
   * - For SLOT_BOOKING orders: releases locked slots
   * - For other order types: additional cleanup as needed
   *
   * If the order is not in PENDING status, the mutation returns without error.
   */
  cancelOrderPayment?: Maybe<Scalars['Void']['output']>;
  /**
   * Process a successful payment.
   *
   * This mutation is called if Wechat indicates the payment is successful. We shall then check if the payment is received and if so, confirm the signup.
   */
  checkEventPayment: GenericMutationResponse;
  /**
   * Check whether the payment results in successful order confirmation.
   *
   * This mutation is called if the WeChat app reports successful payment. The mutation checks with the wepay server if the payment is actually received and if so, confirms the order and performs order-type-specific processing:
   *
   * - For SLOT_BOOKING orders: marks locked slots as BOOKED
   * - For other order types: additional processing as needed
   */
  checkOrderPayment: GenericMutationResponse;
  /** Complete the event and calculate final player ranking */
  completeEvent?: Maybe<Scalars['Void']['output']>;
  /**
   * Get the wepay JSAPI payment arguments for booking the slots.
   *
   * The slots will be locked for a short period after this mutation is called, but the booking is not finalized until the payment is completed.
   *
   * The client is expected the call the `cancelOrderPayment` mutation if the user aborts the payment process, so that the locked slots can be released as soon as possible for other users.
   *
   * In case payment is successful, the client shall use the `checkOrderPayment` mutation to confirm successful booking and update the UI accordingly.
   *
   * **NOTE:** Even in case of successful payment, there might be a slight chance that the booking will fail due to race conditions and `checkOrderPayment` will return an error. In such rare cases, the backend will start an automatic refund process. The client shall be prepared to handle this case gracefully.
   */
  createBookingOrder: CreateBookingOrderResponse;
  /** Creates a new duel. */
  createDuel: Match;
  /** Creates a new event. */
  createEvent: GenericMutationResponse;
  /**
   * If a duel is ended before any score is submitted, then the duel will be deleted
   *  * Who can end the duel?
   */
  endDuel: EndDuelStatus;
  /** Join the given duel on the given side. Note any player can have only **one active** duel at a time. The current active duel must be ended before joining another duel. */
  joinDuel: GenericMutationResponse;
  /**
   * Login mutation for WeApp mini program clients. When a user enters the weapp, this mutation exchanges the weapp-provided `code` for the user's openid and then fetches their profile. The login will always succeed in this scenario even if the user does not exist in the database.
   *
   * Returns the user's basic profile, generates and returns a **new** token, and invalidates the existing token if any.
   *
   * This is a **public** mutation, meaning it does not require an `authToken` in the request header.
   */
  login: LoginResponseUnion;
  /**
   * Login mutation for web SPA admin clients. This mutation handles three scenarios:
   *
   *  * **PC login with QR code**: Authenticates the user with an `openid` obtained when the user scans a login qrcode;
   *  * **Token refresh**: When an `authToken` is found in the browser's local storage, this mutation can be invoked with the token in the request header without any arguments to re-authenticate the user. If the token is invalid or expired, a `GraphqlRequestError` will be returned;
   *  * **WXWork authentication**: When the user accesses the web app from the wxwork client, the user is already authenticated by wxwork, and this mutation will simply return the authenticated user info.
   *
   * Returns the user's basic profile, generates and returns a **new** token, and invalidates the existing token if any.
   *
   * This is a **public** mutation, meaning it does not require an `authToken` in the request header.
   */
  loginAdmin: LoginAdminResponseUnion;
  /**
   * Logout the current user by invalidating their authentication token. After logout, the token will no longer be valid for authentication. Returns a success response if the logout was successful.
   *
   * **Note:** this mutation is only intended to be used by the pc-man application. A weapp user will be not able to logout.
   */
  logout: GenericMutationResponse;
  /**
   * Override slot status and/or price for specific date slots.
   *
   * This is for **site management** to:
   *  * Reserve (block) slots from being booked by users
   *  * Release previously reserved slots (set status=OPEN)
   *  * Override the template price for specific date slots
   *
   * To release a slot: pass status=OPEN. If no price override, the row is deleted.
   * Only RESERVED and OPEN statuses can be set via this mutation.
   *
   * All courts must belong to the same site.
   *
   * **Important:** Slots that are already BOOKED cannot be modified. This prevents accidental modification of slots with existing user bookings.
   */
  overrideSlots: GenericMutationResponse;
  /** Depending on the file metadata, either return the File already uploaded, or return the OSS upload arguments for the browser to upload the file directly to OSS. */
  prepareOssUpload: PrepareOssUploadResponse;
  /**
   * Initiate a refund for a confirmed order. Admin only.
   *
   * Validates that the requested amount does not exceed the net paid amount (total payments minus existing refunds), then starts the WepayRefundWorkflow for the most recent payment of the order.
   */
  refundOrder: GenericMutationResponse;
  /** The player rejects the score of the match. */
  rejectMatchScore: MatchScoreFeedbackResponse;
  /** Removes the player from the duel. */
  removeDuelPlayer?: Maybe<Scalars['Void']['output']>;
  /** Remove a user from a site by deleting their SiteUser record. Requires the caller to be a super_admin of the site. Returns a success response if the removal was successful. */
  removeSiteAdmin: GenericMutationResponse;
  /** Get the payment arguments for paying the signup fee of the event. */
  requestEventPayment: RequestEventPaymentResponse;
  /**
   * Save slot templates for a site.
   *
   * This replaces **all** existing slot templates for the site. Pass an empty list to clear all slots.
   *
   * Weekday is 0=Monday through 6=Sunday. Hour is 0-23.
   */
  saveSlotTemplates?: Maybe<Scalars['Void']['output']>;
  /**
   * Informs the backend that user has scanned a weapp mini action qr with the given qrid on her weapp device.
   * The mutation just publishes the scanned event to the pubsub manager and let any subscribers decide what to do with it.
   */
  scanQrCode?: Maybe<Scalars['Void']['output']>;
  /** Transit the status of the event to `EVENT_STATUS.STARTED`. After event is started, no more signups are allowed and the match plan for the first stage of the event can be generated for the players signed up. */
  startEvent?: Maybe<Scalars['Void']['output']>;
  /**
   * Submit the score of the duel and end the duel at the same time.
   * Note that match sets are updated as a whole, no partial update of a single `MatchSet` is possible.
   */
  submitDuelScore: SubmitDuelScoreResponse;
  /** Log a mock application error. Used for testing error logging pipelines. */
  testLogError: GenericMutationResponse;
  /** Raise an unhandled exception. Used for testing exception logging pipelines. */
  testRaiseException: GenericMutationResponse;
  /** Send a test WXWork text message via messenger-service. Used for verifying the messaging pipeline. */
  testSendMessage: GenericMutationResponse;
  /** Update or add the score of a match in the event. */
  updateEventScore: EventMatch;
  /** Update an existing site. Only site admins can update the site. */
  updateSite: Site;
  /** Update all courts for a site. Pass the complete list of courts with their names and display orders. Courts with id=None will be created, existing courts will be updated. Courts not in the list will cause an error (deletion not allowed). Only super-admins of the site can update courts. */
  updateSiteCourts: Array<Court>;
  /** Update the profile of the current user. */
  updateUserProfile: UpdateUserProfileResponse;
};


export type MutationAcceptMatchScoreArgs = {
  matchId: Scalars['ID']['input'];
  scoreUpdateTime: Scalars['DateTime']['input'];
};


export type MutationAddSiteArgs = {
  siteInput: SiteInput;
};


export type MutationAddSiteAdminArgs = {
  siteId: Scalars['ID']['input'];
  type: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationCancelBookingOrderArgs = {
  slots: Array<SlotBookingInput>;
};


export type MutationCancelEventArgs = {
  eventId: Scalars['UUID']['input'];
};


export type MutationCancelEventPaymentArgs = {
  outTradeNo: Scalars['UUID']['input'];
};


export type MutationCancelEventSignupArgs = {
  eventId: Scalars['UUID']['input'];
};


export type MutationCancelOrderPaymentArgs = {
  orderId: Scalars['UUID']['input'];
};


export type MutationCheckEventPaymentArgs = {
  outTradeNo: Scalars['UUID']['input'];
};


export type MutationCheckOrderPaymentArgs = {
  orderId: Scalars['UUID']['input'];
};


export type MutationCompleteEventArgs = {
  eventId: Scalars['UUID']['input'];
  rankInput: Array<PlayerRankInput>;
};


export type MutationCreateBookingOrderArgs = {
  slots: Array<SlotBookingInput>;
};


export type MutationCreateDuelArgs = {
  matchInput: CreateMatchInput;
};


export type MutationCreateEventArgs = {
  eventInput: CreateEventInput;
};


export type MutationEndDuelArgs = {
  matchId: Scalars['ID']['input'];
};


export type MutationJoinDuelArgs = {
  matchId: Scalars['ID']['input'];
  side: Scalars['Int']['input'];
};


export type MutationLoginArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationLoginAdminArgs = {
  openid?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationOverrideSlotsArgs = {
  slots: Array<SlotOverrideInput>;
};


export type MutationPrepareOssUploadArgs = {
  uploadInput: FileUploadInput;
};


export type MutationRefundOrderArgs = {
  amount: Scalars['Decimal']['input'];
  orderId: Scalars['UUID']['input'];
};


export type MutationRejectMatchScoreArgs = {
  matchId: Scalars['ID']['input'];
  scoreUpdateTime: Scalars['DateTime']['input'];
};


export type MutationRemoveDuelPlayerArgs = {
  matchId: Scalars['ID']['input'];
  playerUserId: Scalars['ID']['input'];
};


export type MutationRemoveSiteAdminArgs = {
  siteId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationRequestEventPaymentArgs = {
  paymentInput: RequestEventPaymentInput;
};


export type MutationSaveSlotTemplatesArgs = {
  siteId: Scalars['ID']['input'];
  slots: Array<SlotTemplateSlotInput>;
};


export type MutationScanQrCodeArgs = {
  qrid: Scalars['ID']['input'];
};


export type MutationStartEventArgs = {
  eventId: Scalars['UUID']['input'];
};


export type MutationSubmitDuelScoreArgs = {
  matchId: Scalars['ID']['input'];
  sets: Array<MatchSetInput>;
};


export type MutationUpdateEventScoreArgs = {
  eventId: Scalars['UUID']['input'];
  scoreInput: UpdateEventScoreInput;
};


export type MutationUpdateSiteArgs = {
  siteId: Scalars['ID']['input'];
  siteInput: SiteInput;
};


export type MutationUpdateSiteCourtsArgs = {
  courts: Array<CourtInput>;
  siteId: Scalars['ID']['input'];
};


export type MutationUpdateUserProfileArgs = {
  userProfile: UpdateUserProfileInput;
};

export type Order = {
  __typename: 'Order';
  amount: Scalars['Decimal']['output'];
  cancelTime?: Maybe<Scalars['DateTime']['output']>;
  createTime: Scalars['DateTime']['output'];
  detail?: Maybe<Array<SlotBooking>>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  /**
   * JSAPI payment parameters for resuming a pending payment.
   *
   * Only present when the order status is PENDING and a WeChat Pay payment request was previously initiated. Only returned by the direct order query (by ID), not the orders list.
   */
  jsapiPaymentParams?: Maybe<JsapiPaymentParams>;
  orderType: OrderType;
  payTime?: Maybe<Scalars['DateTime']['output']>;
  payments: Array<PaymentType>;
  siteId?: Maybe<Scalars['UUID']['output']>;
  status: OrderStatus;
  user: UserBasic;
  userId: Scalars['UUID']['output'];
};

export type OrderConnection = {
  __typename: 'OrderConnection';
  /** A list of edges in this connection. */
  edges: Array<OrderEdge>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type OrderEdge = {
  __typename: 'OrderEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Order;
};

export type OrderFilterInput = {
  adminView?: Scalars['Boolean']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  orderStatus?: InputMaybe<OrderStatus>;
  orderType?: InputMaybe<OrderType>;
  siteId?: InputMaybe<Scalars['UUID']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum OrderStatus {
  Cancelled = 'CANCELLED',
  Closed = 'CLOSED',
  Confirmed = 'CONFIRMED',
  Pending = 'PENDING'
}

export enum OrderType {
  Coaching = 'COACHING',
  EventSignup = 'EVENT_SIGNUP',
  Goods = 'GOODS',
  Membership = 'MEMBERSHIP',
  SlotBooking = 'SLOT_BOOKING'
}

export type PageInfo = {
  __typename: 'PageInfo';
  /** Cursor of the last item in the paginated list or null if the list is empty. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
};

export type PaymentType = {
  __typename: 'PaymentType';
  /** Payment amount in CNY. Positive for payments, negative for refunds. */
  amount: Scalars['Decimal']['output'];
  createTime: Scalars['DateTime']['output'];
  creatorName?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  payTime?: Maybe<Scalars['DateTime']['output']>;
};

export type PlayerRankInput = {
  /** The user ID of the player */
  playerUserId: Scalars['UUID']['input'];
  /** The rank of the player in the event */
  rank: Scalars['Int']['input'];
};

export type PrepareOssUploadResponse = File | FileUploadArgs;

export enum QrStatus {
  Confirmed = 'CONFIRMED',
  Expired = 'EXPIRED',
  Scanned = 'SCANNED'
}

export type Query = {
  __typename: 'Query';
  /** Return all sites administered by the authenticated user */
  adminSites: Array<Site>;
  /** List all users of a site. Requires super_admin role. */
  adminUsers: Array<AdminUser>;
  /** Get the current duel for the authenticated user. Any player can have only **one active** duel at a time. */
  currentDuel?: Maybe<Match>;
  currentUser?: Maybe<UserBasic>;
  /** Fetch all **ended** duels of the authenticated user, sorted by create time and paginated. */
  duels: MatchConnection;
  event: Event;
  events: EventConnection;
  match: Match;
  /** Return a single order by its ID. Site admins and super admins can fetch any order for their site; regular users can only fetch their own orders. */
  order: Order;
  /** Return orders visible to the authenticated user. When filter.adminView is true, the user must be a site admin or super admin and all orders for the site are returned. Otherwise, only the authenticated user's own orders are returned. filter.siteId is optional; when omitted, orders across all sites are returned (subject to visibility rules). */
  orders: OrderConnection;
  /** Return the information about a site. This is a public query and does not require authentication. */
  site: Site;
  /**
   * Return all slot templates for a site across all weekdays.
   * Weekday values are 0=Monday through 6=Sunday.
   */
  slotTemplates: Array<SlotTemplate>;
  /**
   * Return the complete list of slots for the specified site on the given date.
   *
   * **For future dates (including today):** Returns all slots derived from templates, with any status/price overrides applied.
   *
   * **For past dates:** Returns only slots with actual usage records (booked, locked, or reserved slots). Template-only slots are excluded since templates define future availability, not historical usage.
   *
   * The slots are returned **unsorted**.
   */
  slots: Array<Slot>;
};


export type QueryAdminUsersArgs = {
  siteId: Scalars['UUID']['input'];
};


export type QueryDuelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: Scalars['Int']['input'];
};


export type QueryEventArgs = {
  id: Scalars['ID']['input'];
};


export type QueryEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: Scalars['Int']['input'];
  tab?: EventFilterTab;
};


export type QueryMatchArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOrderArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<OrderFilterInput>;
  first?: Scalars['Int']['input'];
};


export type QuerySiteArgs = {
  siteId?: InputMaybe<Scalars['UUID']['input']>;
};


export type QuerySlotTemplatesArgs = {
  siteId: Scalars['UUID']['input'];
};


export type QuerySlotsArgs = {
  date: Scalars['Date']['input'];
  siteId: Scalars['UUID']['input'];
};

/** Error codes for business logic errors that users can encounter during normal operation. These errors represent valid application states that can occur through normal UI usage (e.g., race conditions, resource exhaustion, state conflicts). They are displayed to users with localized error messages. DO NOT use these for programming errors (use RuntimeError), input validation errors (use ValueError or Pydantic validators), or authorization errors (use appropriate HTTP status codes). */
export enum RequestErrorCode {
  /** The user is already a member of this site. */
  AdminAlreadyExists = 'ADMIN_ALREADY_EXISTS',
  /** The user has already joined the duel. */
  DuelAlreadyJoined = 'DUEL_ALREADY_JOINED',
  /** The user has already joined another active duel. */
  DuelAnotherExisting = 'DUEL_ANOTHER_EXISTING',
  /** The match is already fully joined, i.e. there are already 2 players in a singles match or 4 players in a doubles match. */
  DuelFullyJoined = 'DUEL_FULLY_JOINED',
  /** A user attempts to accept or reject the match score, but the match score has been changed since the user last fetched it. */
  DuelScoreChanged = 'DUEL_SCORE_CHANGED',
  /** The creator attempts to modify the match score, but the match score has already been confirmed by all players. */
  DuelScoreConfirmed = 'DUEL_SCORE_CONFIRMED',
  /** The match is already full on the requested side, i.e. there are already 2 players in a doubles match or 1 player in a singles match. */
  DuelSideFull = 'DUEL_SIDE_FULL',
  /** The user has already signed up for the event. */
  EventAlreadySignedUp = 'EVENT_ALREADY_SIGNED_UP',
  /** The user has no confirmed signup for the event. */
  EventNoConfirmedSignup = 'EVENT_NO_CONFIRMED_SIGNUP',
  /** No free slot is available in the event at the moment. */
  EventNoFreeSlot = 'EVENT_NO_FREE_SLOT',
  /** The user has already one payment request for the event. */
  EventPaymentInProgress = 'EVENT_PAYMENT_IN_PROGRESS',
  /** The payment for the event has not been received yet. This shall never happen. */
  EventPaymentNotReceived = 'EVENT_PAYMENT_NOT_RECEIVED',
  /** The provided login token is invalid or expired. */
  LoginInvalidToken = 'LOGIN_INVALID_TOKEN',
  /** The payment has not been received by the payment provider. */
  PaymentNotFound = 'PAYMENT_NOT_FOUND',
  /** The requested refund amount exceeds the net paid amount for the order. */
  RefundExceedsPayment = 'REFUND_EXCEEDS_PAYMENT',
  /** Cannot override a slot that is already booked by a user. */
  SlotAlreadyBooked = 'SLOT_ALREADY_BOOKED',
  /** The requested slot is not available for booking (already booked, locked, or reserved). */
  SlotNotAvailable = 'SLOT_NOT_AVAILABLE'
}

export type RequestEventPaymentInput = {
  /** The amount to be paid in cents, >=1 */
  amount: Scalars['Int']['input'];
  /** The ID of the event */
  eventId: Scalars['UUID']['input'];
};

export type RequestEventPaymentResponse = CreateOrderResponse | GraphqlRequestError;

/** A `Site` is a physical location where players can play in the courts. */
export type Site = {
  __typename: 'Site';
  /** The list of courts available at this site. */
  courts: Array<Court>;
  /** The unique identifier of the site. */
  id: Scalars['UUID']['output'];
  /** File names of images for the site. */
  images?: Maybe<Array<Scalars['String']['output']>>;
  /** The physical location/address of the site. */
  location: Scalars['String']['output'];
  /** The name of the site. */
  name: Scalars['String']['output'];
  /** Contact phone number for the site. */
  phone: Scalars['String']['output'];
};

export type SiteAdmin = User & {
  __typename: 'SiteAdmin';
  /** The file name of the user avatar image. */
  avatar?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Gender>;
  /** The unique identifier for the user in the database */
  id?: Maybe<Scalars['ID']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
  /** The name the user choose to display in the app, can be anything. */
  name?: Maybe<Scalars['String']['output']>;
  openid: Scalars['ID']['output'];
  ratingSingles?: Maybe<Scalars['Float']['output']>;
  /** The sites this user administers. */
  sites: Array<SiteAdminInfoType>;
};

/** A site with the admin role information. */
export type SiteAdminInfoType = {
  __typename: 'SiteAdminInfoType';
  /** The unique identifier of the site. */
  id: Scalars['UUID']['output'];
  /** The name of the site. */
  name: Scalars['String']['output'];
  /** The role of the admin user at this site. */
  role: Scalars['String']['output'];
};

/** Input for creating a new site. */
export type SiteInput = {
  /** URLs of images for the site. */
  images?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The physical location/address of the site. */
  location: Scalars['String']['input'];
  /** The name of the site. */
  name: Scalars['String']['input'];
  /** Contact phone number for the site. */
  phone: Scalars['String']['input'];
};

/**
 * A `Slot` is the smallest booking unit.
 * A user will be able to book more than one slots in one order.
 */
export type Slot = {
  __typename: 'Slot';
  /** The unique identifier of the court. */
  courtId: Scalars['UUID']['output'];
  /** The event associated with this slot usage, if any. */
  eventId?: Maybe<Scalars['UUID']['output']>;
  /** The order associated with this slot usage. Only present for BOOKED and LOCKED slots. */
  orderId?: Maybe<Scalars['UUID']['output']>;
  /**
   * The price of the slot in CNY.
   * For BOOKED and LOCKED slots, this is the price actually paid (or to be paid). For other slots, this is the current list price.
   */
  price?: Maybe<Scalars['Decimal']['output']>;
  /** The reason for slot override (e.g., reservation reason). */
  reason?: Maybe<Scalars['String']['output']>;
  /**
   * The start date & time of the slot.
   * In the current application all slots start at the beginning of an hour.
   */
  startTime: Scalars['DateTime']['output'];
  /** The current status of the slot. */
  status: SlotStatus;
  /** The user who created this slot usage. Only present for BOOKED and LOCKED slots. */
  userId?: Maybe<Scalars['UUID']['output']>;
};

export type SlotBooking = {
  __typename: 'SlotBooking';
  /** The unique identifier of the court. */
  courtId: Scalars['UUID']['output'];
  /** The name of the court. */
  courtName: Scalars['String']['output'];
  /**
   * The price of the slot in CNY.
   * This is included because between the time a user initiates a booking and the time the booking is completed, the price may change. In case of such price conflicts, the price that the users initially see shall be the definitive price they will pay.
   */
  price: Scalars['Decimal']['output'];
  /**
   * The start date & time of the slot.
   * In the current application all slots start at the beginning of an hour.
   */
  startTime: Scalars['DateTime']['output'];
};

export type SlotBookingInput = {
  /** The unique identifier of the court. */
  courtId: Scalars['UUID']['input'];
  /**
   * The price of the slot in CNY.
   * This is included because between the time a user initiates a booking and the time the booking is completed, the price may change. In case of such price conflicts, the price that the users initially see shall be the definitive price they will pay.
   */
  price: Scalars['Decimal']['input'];
  /**
   * The start date & time of the slot.
   * In the current application all slots start at the beginning of an hour.
   */
  startTime: Scalars['DateTime']['input'];
};

/**
 * Input for overriding slot status or price. Exactly one of `status` or `price` must be provided (not both, not neither).
 *
 * To reserve a slot: set status=RESERVED (existing price override is preserved).
 * To release a slot: set status=OPEN (existing price override is preserved; if no price override exists, the row is deleted).
 * To override price only: set price (existing status is preserved).
 */
export type SlotOverrideInput = {
  courtId: Scalars['UUID']['input'];
  price?: InputMaybe<Scalars['Decimal']['input']>;
  /** Optional reason for the slot override (max 100 characters). */
  reason?: InputMaybe<Scalars['String']['input']>;
  startTime: Scalars['DateTime']['input'];
  status?: InputMaybe<SlotStatus>;
};

/** Status of a booking slot: OPEN, LOCKED, BOOKED, RESERVED */
export enum SlotStatus {
  Booked = 'BOOKED',
  Locked = 'LOCKED',
  Open = 'OPEN',
  Reserved = 'RESERVED'
}

/** A `SlotTemplate` defines the price for a specific court/weekday/hour combination. Combinations without a template are considered unavailable. */
export type SlotTemplate = {
  __typename: 'SlotTemplate';
  /** The court this slot template belongs to. */
  courtId: Scalars['UUID']['output'];
  /** Hour of day (0-23). */
  hour: Scalars['Int']['output'];
  /** The price in CNY for this slot. */
  price: Scalars['Decimal']['output'];
  /** Day of week. */
  weekday: Weekday;
};

/** Input for a single slot in a slot template. Defines the price for a specific court, weekday, and hour. */
export type SlotTemplateSlotInput = {
  /** The court ID. */
  courtId: Scalars['UUID']['input'];
  /** Hour of day (0-23). */
  hour: Scalars['Int']['input'];
  /** The price in CNY for this slot. */
  price: Scalars['Decimal']['input'];
  /** Day of week. */
  weekday: Weekday;
};

export type SubmitDuelScoreResponse = GraphqlRequestError | MatchScoreUpdated;

export type Subscription = {
  __typename: 'Subscription';
  actionQrScanned: ActionQrStatus;
  duelJoined: DuelJoinedEvent;
};


export type SubscriptionActionQrScannedArgs = {
  qrid: Scalars['ID']['input'];
};


export type SubscriptionDuelJoinedArgs = {
  matchId: Scalars['ID']['input'];
};

export type UpdateEventScoreInput = {
  /** The round number */
  round: Scalars['Int']['input'];
  /** The player ID of side 1 */
  side1PlayerId: Scalars['UUID']['input'];
  /** Score of side 1 */
  side1Score: Scalars['Int']['input'];
  /** Tie break score of side 1, if applicable */
  side1TiebreakPoints?: InputMaybe<Scalars['Int']['input']>;
  /** The player ID of side 2 */
  side2PlayerId: Scalars['UUID']['input'];
  /** Score of side 2 */
  side2Score: Scalars['Int']['input'];
  /** Tie break score of side 2, if applicable */
  side2TiebreakPoints?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateUserProfileInput = {
  accountBankName?: InputMaybe<Scalars['String']['input']>;
  accountHolderName?: InputMaybe<Scalars['String']['input']>;
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  /** The initial rating of the user when they first register. */
  initialRating?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** The code to be used in exchange for the user's actual mobile number. */
  phoneCode?: InputMaybe<Scalars['String']['input']>;
  pin?: InputMaybe<Scalars['String']['input']>;
  realName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserProfileResponse = GraphqlRequestError | UserBasic;

export type User = {
  /** The file name of the user avatar image. */
  avatar?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Gender>;
  /** The unique identifier for the user in the database */
  id?: Maybe<Scalars['ID']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
  /** The name the user choose to display in the app, can be anything. */
  name?: Maybe<Scalars['String']['output']>;
  /** Openid is the unique identifier for the user. */
  openid: Scalars['ID']['output'];
  ratingSingles?: Maybe<Scalars['Float']['output']>;
};

export type UserBasic = User & {
  __typename: 'UserBasic';
  /** The file name of the user avatar image. */
  avatar?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Gender>;
  /** The unique identifier for the user in the database */
  id?: Maybe<Scalars['ID']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
  /** The name the user choose to display in the app, can be anything. */
  name?: Maybe<Scalars['String']['output']>;
  openid: Scalars['ID']['output'];
  ratingSingles?: Maybe<Scalars['Float']['output']>;
};

/** Day of week: MONDAY=0, ..., SUNDAY=6 */
export enum Weekday {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type AddSiteMutationVariables = Exact<{
  siteInput: SiteInput;
}>;


export type AddSiteMutation = { __typename: 'Mutation', addSite: { __typename: 'Site', id: string, name: string, location: string } };

export type ActionQrScannedSubscriptionVariables = Exact<{
  qrid: Scalars['ID']['input'];
}>;


export type ActionQrScannedSubscription = { __typename: 'Subscription', actionQrScanned: { __typename: 'ActionQrStatus', qrid: string, status: QrStatus, userId?: string | null, openid: string } };

export type UserLoginAdminMutationVariables = Exact<{
  openid?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UserLoginAdminMutation = { __typename: 'Mutation', loginAdmin:
    | { __typename: 'GraphqlRequestError', message?: string | null, code: RequestErrorCode }
    | { __typename: 'LoginAdminResponse', authToken: string, user: (
        { __typename: 'SiteAdmin', openid: string, sites: Array<{ __typename: 'SiteAdminInfoType', id: string, name: string, role: string }> }
        & { ' $fragmentRefs'?: { 'BasicUserFields_SiteAdmin_Fragment': BasicUserFields_SiteAdmin_Fragment } }
      ) }
   };

export type UserLogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type UserLogoutMutation = { __typename: 'Mutation', logout:
    | { __typename: 'GraphqlRequestError', message?: string | null, code: RequestErrorCode }
    | { __typename: 'GraphqlSuccess', success: boolean }
   };

type BasicUserFields_AdminUser_Fragment = { __typename: 'AdminUser', id?: string | null, name?: string | null, avatar?: string | null, openid: string, mobile?: string | null, gender?: Gender | null } & { ' $fragmentName'?: 'BasicUserFields_AdminUser_Fragment' };

type BasicUserFields_SiteAdmin_Fragment = { __typename: 'SiteAdmin', id?: string | null, name?: string | null, avatar?: string | null, openid: string, mobile?: string | null, gender?: Gender | null } & { ' $fragmentName'?: 'BasicUserFields_SiteAdmin_Fragment' };

type BasicUserFields_UserBasic_Fragment = { __typename: 'UserBasic', id?: string | null, name?: string | null, avatar?: string | null, openid: string, mobile?: string | null, gender?: Gender | null } & { ' $fragmentName'?: 'BasicUserFields_UserBasic_Fragment' };

export type BasicUserFieldsFragment =
  | BasicUserFields_AdminUser_Fragment
  | BasicUserFields_SiteAdmin_Fragment
  | BasicUserFields_UserBasic_Fragment
;

export type GetCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentUserQuery = { __typename: 'Query', currentUser?: (
    { __typename: 'UserBasic' }
    & { ' $fragmentRefs'?: { 'BasicUserFields_UserBasic_Fragment': BasicUserFields_UserBasic_Fragment } }
  ) | null };

export type UpdateUserBasicMutationVariables = Exact<{
  userProfile: UpdateUserProfileInput;
}>;


export type UpdateUserBasicMutation = { __typename: 'Mutation', updateUserProfile:
    | { __typename: 'GraphqlRequestError' }
    | (
      { __typename: 'UserBasic' }
      & { ' $fragmentRefs'?: { 'BasicUserFields_UserBasic_Fragment': BasicUserFields_UserBasic_Fragment } }
    )
   };

export type SiteQueryVariables = Exact<{
  siteId: Scalars['UUID']['input'];
}>;


export type SiteQuery = { __typename: 'Query', site: { __typename: 'Site', id: string, name: string, location: string, phone: string, images?: Array<string> | null, courts: Array<{ __typename: 'Court', id: string, name: string, displayOrder: number }> } };

export type UpdateSiteMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
  siteInput: SiteInput;
}>;


export type UpdateSiteMutation = { __typename: 'Mutation', updateSite: { __typename: 'Site', id: string, name: string, location: string, phone: string, images?: Array<string> | null } };

export type UpdateSiteCourtsMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
  courts: Array<CourtInput> | CourtInput;
}>;


export type UpdateSiteCourtsMutation = { __typename: 'Mutation', updateSiteCourts: Array<{ __typename: 'Court', id: string, name: string, displayOrder: number }> };

export type GetOrderDetailQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetOrderDetailQuery = { __typename: 'Query', order: { __typename: 'Order', id: string, siteId?: string | null, status: OrderStatus, amount: any, createTime: string, payTime?: string | null, cancelTime?: string | null, expiresAt?: string | null, detail?: Array<{ __typename: 'SlotBooking', courtId: string, courtName: string, price: any, startTime: string }> | null, user: { __typename: 'UserBasic', id?: string | null, name?: string | null, mobile?: string | null, avatar?: string | null, openid: string }, payments: Array<{ __typename: 'PaymentType', id: string, amount: any, createTime: string, payTime?: string | null, creatorName?: string | null }> } };

export type RefundOrderMutationVariables = Exact<{
  orderId: Scalars['UUID']['input'];
  amount: Scalars['Decimal']['input'];
}>;


export type RefundOrderMutation = { __typename: 'Mutation', refundOrder:
    | { __typename: 'GraphqlRequestError', code: RequestErrorCode, message?: string | null }
    | { __typename: 'GraphqlSuccess' }
   };

export type OrdersQueryVariables = Exact<{
  filter?: InputMaybe<OrderFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type OrdersQuery = { __typename: 'Query', orders: { __typename: 'OrderConnection', edges: Array<{ __typename: 'OrderEdge', node: { __typename: 'Order', id: string, orderType: OrderType, status: OrderStatus, amount: any, createTime: string, payTime?: string | null, expiresAt?: string | null, detail?: Array<{ __typename: 'SlotBooking', courtName: string, startTime: string, price: any }> | null, user: { __typename: 'UserBasic', id?: string | null, name?: string | null, mobile?: string | null, avatar?: string | null, openid: string } } }>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } };

export type AdminSitesQueryVariables = Exact<{ [key: string]: never; }>;


export type AdminSitesQuery = { __typename: 'Query', adminSites: Array<{ __typename: 'Site', id: string, name: string, location: string, images?: Array<string> | null, courts: Array<{ __typename: 'Court', id: string, name: string, displayOrder: number }> }> };

export type SlotTemplatesQueryVariables = Exact<{
  siteId: Scalars['UUID']['input'];
}>;


export type SlotTemplatesQuery = { __typename: 'Query', slotTemplates: Array<{ __typename: 'SlotTemplate', courtId: string, weekday: Weekday, hour: number, price: any }> };

export type SaveSlotTemplatesMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
  slots: Array<SlotTemplateSlotInput> | SlotTemplateSlotInput;
}>;


export type SaveSlotTemplatesMutation = { __typename: 'Mutation', saveSlotTemplates?: void | null };

export type SlotsQueryVariables = Exact<{
  siteId: Scalars['UUID']['input'];
  date: Scalars['Date']['input'];
}>;


export type SlotsQuery = { __typename: 'Query', slots: Array<{ __typename: 'Slot', courtId: string, startTime: string, price?: any | null, status: SlotStatus, reason?: string | null, orderId?: string | null }> };

export type OverrideSlotsMutationVariables = Exact<{
  slots: Array<SlotOverrideInput> | SlotOverrideInput;
}>;


export type OverrideSlotsMutation = { __typename: 'Mutation', overrideSlots:
    | { __typename: 'GraphqlRequestError', message?: string | null, code: RequestErrorCode }
    | { __typename: 'GraphqlSuccess', success: boolean }
   };

export type TestLogErrorMutationVariables = Exact<{ [key: string]: never; }>;


export type TestLogErrorMutation = { __typename: 'Mutation', testLogError:
    | { __typename: 'GraphqlRequestError', code: RequestErrorCode, message?: string | null }
    | { __typename: 'GraphqlSuccess', success: boolean }
   };

export type TestRaiseExceptionMutationVariables = Exact<{ [key: string]: never; }>;


export type TestRaiseExceptionMutation = { __typename: 'Mutation', testRaiseException:
    | { __typename: 'GraphqlRequestError', code: RequestErrorCode, message?: string | null }
    | { __typename: 'GraphqlSuccess', success: boolean }
   };

export type TestSendMessageMutationVariables = Exact<{ [key: string]: never; }>;


export type TestSendMessageMutation = { __typename: 'Mutation', testSendMessage:
    | { __typename: 'GraphqlRequestError', code: RequestErrorCode, message?: string | null }
    | { __typename: 'GraphqlSuccess', success: boolean }
   };

export type AdminUsersQueryVariables = Exact<{
  siteId: Scalars['UUID']['input'];
}>;


export type AdminUsersQuery = { __typename: 'Query', adminUsers: Array<{ __typename: 'AdminUser', id?: string | null, openid: string, name?: string | null, avatar?: string | null, mobile?: string | null, gender?: Gender | null, role: string }> };

export type AddSiteAdminMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
  type: Scalars['String']['input'];
}>;


export type AddSiteAdminMutation = { __typename: 'Mutation', addSiteAdmin:
    | { __typename: 'GraphqlRequestError', code: RequestErrorCode, message?: string | null }
    | { __typename: 'GraphqlSuccess', success: boolean }
   };

export type RemoveSiteAdminMutationVariables = Exact<{
  siteId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type RemoveSiteAdminMutation = { __typename: 'Mutation', removeSiteAdmin:
    | { __typename: 'GraphqlRequestError' }
    | { __typename: 'GraphqlSuccess', success: boolean }
   };

export type PrepareOssUploadMutationVariables = Exact<{
  uploadInput: FileUploadInput;
}>;


export type PrepareOssUploadMutation = { __typename: 'Mutation', prepareOssUpload:
    | { __typename: 'File', name: string, url: string }
    | { __typename: 'FileUploadArgs', bucketUrl: string, key: string, OSSAccessKeyId: string, policy: string, Signature: string, SecurityToken: string, callback: string }
   };

export const BasicUserFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BasicUserFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"openid"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}}]}}]} as unknown as DocumentNode<BasicUserFieldsFragment, unknown>;
export const AddSiteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddSite"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"siteInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SiteInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addSite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"siteInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"siteInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"location"}}]}}]}}]} as unknown as DocumentNode<AddSiteMutation, AddSiteMutationVariables>;
export const ActionQrScannedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"ActionQrScanned"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"qrid"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"actionQrScanned"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"qrid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"qrid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"qrid"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"openid"}}]}}]}}]} as unknown as DocumentNode<ActionQrScannedSubscription, ActionQrScannedSubscriptionVariables>;
export const UserLoginAdminDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UserLoginAdmin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"openid"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loginAdmin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"openid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"openid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LoginAdminResponse"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authToken"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"openid"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BasicUserFields"}},{"kind":"Field","name":{"kind":"Name","value":"sites"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}}]}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GraphqlRequestError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BasicUserFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"openid"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}}]}}]} as unknown as DocumentNode<UserLoginAdminMutation, UserLoginAdminMutationVariables>;
export const UserLogoutDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UserLogout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logout"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GraphqlSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GraphqlRequestError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<UserLogoutMutation, UserLogoutMutationVariables>;
export const GetCurrentUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCurrentUser"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentUser"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BasicUserFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BasicUserFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"openid"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}}]}}]} as unknown as DocumentNode<GetCurrentUserQuery, GetCurrentUserQueryVariables>;
export const UpdateUserBasicDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserBasic"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userProfile"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateUserProfileInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUserProfile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userProfile"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userProfile"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BasicUserFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BasicUserFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"openid"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}}]}}]} as unknown as DocumentNode<UpdateUserBasicMutation, UpdateUserBasicMutationVariables>;
export const SiteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Site"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"site"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"siteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"images"}},{"kind":"Field","name":{"kind":"Name","value":"courts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"displayOrder"}}]}}]}}]}}]} as unknown as DocumentNode<SiteQuery, SiteQueryVariables>;
export const UpdateSiteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateSite"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"siteInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SiteInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateSite"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"siteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}}},{"kind":"Argument","name":{"kind":"Name","value":"siteInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"siteInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"images"}}]}}]}}]} as unknown as DocumentNode<UpdateSiteMutation, UpdateSiteMutationVariables>;
export const UpdateSiteCourtsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateSiteCourts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"courts"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CourtInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateSiteCourts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"siteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}}},{"kind":"Argument","name":{"kind":"Name","value":"courts"},"value":{"kind":"Variable","name":{"kind":"Name","value":"courts"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"displayOrder"}}]}}]}}]} as unknown as DocumentNode<UpdateSiteCourtsMutation, UpdateSiteCourtsMutationVariables>;
export const GetOrderDetailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetOrderDetail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"siteId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"detail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"courtId"}},{"kind":"Field","name":{"kind":"Name","value":"courtName"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"openid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"payTime"}},{"kind":"Field","name":{"kind":"Name","value":"creatorName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"payTime"}},{"kind":"Field","name":{"kind":"Name","value":"cancelTime"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}}]}}]}}]} as unknown as DocumentNode<GetOrderDetailQuery, GetOrderDetailQueryVariables>;
export const RefundOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RefundOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"amount"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Decimal"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"refundOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"amount"},"value":{"kind":"Variable","name":{"kind":"Name","value":"amount"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GraphqlSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GraphqlRequestError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<RefundOrderMutation, RefundOrderMutationVariables>;
export const OrdersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Orders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderFilterInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"orderType"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"detail"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"courtName"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"openid"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createTime"}},{"kind":"Field","name":{"kind":"Name","value":"payTime"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]} as unknown as DocumentNode<OrdersQuery, OrdersQueryVariables>;
export const AdminSitesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminSites"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminSites"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"location"}},{"kind":"Field","name":{"kind":"Name","value":"images"}},{"kind":"Field","name":{"kind":"Name","value":"courts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"displayOrder"}}]}}]}}]}}]} as unknown as DocumentNode<AdminSitesQuery, AdminSitesQueryVariables>;
export const SlotTemplatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SlotTemplates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slotTemplates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"siteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"courtId"}},{"kind":"Field","name":{"kind":"Name","value":"weekday"}},{"kind":"Field","name":{"kind":"Name","value":"hour"}},{"kind":"Field","name":{"kind":"Name","value":"price"}}]}}]}}]} as unknown as DocumentNode<SlotTemplatesQuery, SlotTemplatesQueryVariables>;
export const SaveSlotTemplatesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SaveSlotTemplates"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slots"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SlotTemplateSlotInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"saveSlotTemplates"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"siteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}}},{"kind":"Argument","name":{"kind":"Name","value":"slots"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slots"}}}]}]}}]} as unknown as DocumentNode<SaveSlotTemplatesMutation, SaveSlotTemplatesMutationVariables>;
export const SlotsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Slots"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"date"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"slots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"siteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}}},{"kind":"Argument","name":{"kind":"Name","value":"date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"date"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"courtId"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"reason"}},{"kind":"Field","name":{"kind":"Name","value":"orderId"}}]}}]}}]} as unknown as DocumentNode<SlotsQuery, SlotsQueryVariables>;
export const OverrideSlotsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"OverrideSlots"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slots"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SlotOverrideInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"overrideSlots"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slots"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slots"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GraphqlSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GraphqlRequestError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]}}]} as unknown as DocumentNode<OverrideSlotsMutation, OverrideSlotsMutationVariables>;
export const TestLogErrorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TestLogError"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"testLogError"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GraphqlSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GraphqlRequestError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<TestLogErrorMutation, TestLogErrorMutationVariables>;
export const TestRaiseExceptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TestRaiseException"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"testRaiseException"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GraphqlSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GraphqlRequestError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<TestRaiseExceptionMutation, TestRaiseExceptionMutationVariables>;
export const TestSendMessageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"TestSendMessage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"testSendMessage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GraphqlSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GraphqlRequestError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<TestSendMessageMutation, TestSendMessageMutationVariables>;
export const AdminUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UUID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adminUsers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"siteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"openid"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"avatar"}},{"kind":"Field","name":{"kind":"Name","value":"mobile"}},{"kind":"Field","name":{"kind":"Name","value":"gender"}},{"kind":"Field","name":{"kind":"Name","value":"role"}}]}}]}}]} as unknown as DocumentNode<AdminUsersQuery, AdminUsersQueryVariables>;
export const AddSiteAdminDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddSiteAdmin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addSiteAdmin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"siteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}}},{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GraphqlSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GraphqlRequestError"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}}]}}]}}]} as unknown as DocumentNode<AddSiteAdminMutation, AddSiteAdminMutationVariables>;
export const RemoveSiteAdminDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveSiteAdmin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeSiteAdmin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"siteId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}}},{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GraphqlSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]}}]} as unknown as DocumentNode<RemoveSiteAdminMutation, RemoveSiteAdminMutationVariables>;
export const PrepareOssUploadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PrepareOssUpload"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uploadInput"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FileUploadInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"prepareOssUpload"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"uploadInput"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uploadInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"File"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FileUploadArgs"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bucketUrl"}},{"kind":"Field","name":{"kind":"Name","value":"key"}},{"kind":"Field","name":{"kind":"Name","value":"OSSAccessKeyId"}},{"kind":"Field","name":{"kind":"Name","value":"policy"}},{"kind":"Field","name":{"kind":"Name","value":"Signature"}},{"kind":"Field","name":{"kind":"Name","value":"SecurityToken"}},{"kind":"Field","name":{"kind":"Name","value":"callback"}}]}}]}}]}}]} as unknown as DocumentNode<PrepareOssUploadMutation, PrepareOssUploadMutationVariables>;